import React, { Fragment, memo, useState } from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import { CAC_PROJECT_TITLE_LENGTH, CAC_MODULE_TITLE, CAC_MAX_LIMIT_REACHED_LABEL } from '../CacConstants';

const saveWarningModalStyle = {
  width: '40%',
  top: '30%',
  left: '30%',
};

const CrosstabSaveReplaceModalStyle = {
  width: '33%',
  height: 'auto',
  left: '36%',
  top: '15%',
};

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};

function CacModals({
  saveWarningModal, setSaveWarningModal, saveAsModal, setSaveAsModal,
  projectName, saveProject, tempTitle, pid = 0, projectCount, showMaxLimitPopup,
  showMaxLimitModal, maxLimitModal, closeSaveAsModal, saveFromCloseProject,
  setSaveFromCloseProject,
}) {
  const [fileName, setFileName] = useState(tempTitle || projectName);
  const [filenameLabel] = useState(tempTitle || projectName);

  const handleSaveAsClick = () => {
    if (projectCount < 15) {
      saveProject({ title: fileName, pid: 0, newProject: true });
      setSaveAsModal(false);
    } else {
      setSaveAsModal(false);
      showMaxLimitPopup();
    }
  };

  return (<Fragment>
    <PortalModal
      isShowing={saveWarningModal}
      title="Unable to Save Project"
      hide={() => setSaveWarningModal(false)}
      onCloseClicked={() => {
        setSaveWarningModal(false);
        setSaveFromCloseProject(false);
      }}
      dialogStyles={saveWarningModalStyle}
    >
      <p>Please add minimum of 3 rows and 3 columns to save a project</p>
    </PortalModal>
    <PortalModal
      isShowing={saveAsModal}
      title="Save as"
      hide={() => setSaveAsModal(false)}
      onCloseClicked={() => closeSaveAsModal()}
      dialogStyles={CrosstabSaveReplaceModalStyle}
    >
      <p>
        Filename <b>{filenameLabel}</b> already exists. A Project with the same name
        already exists in your account. Would you like to save as a new name?
      </p>
      <div className="row crossTabNameModal padding-left-10 save-as-modal">
        <input
          type="text"
          placeholder="Enter Project Name"
          className="display-inline width-200"
          value={fileName}
          maxLength={CAC_PROJECT_TITLE_LENGTH}
          onChange={e => {
            if (e.target.value.length === 0 || e.target.value.trim()) {
              setFileName(e.target.value);
            }
          }
        }
        />
        <GenericButton
          name="Save"
          btnStyle="button btn-cncl save-as-modal-save"
          btnDisabled={fileName.trim() === projectName}
          onBtnClick={() => {
            const closeProject = saveFromCloseProject ? true : undefined;
            saveProject({ title: fileName, pid, closeProject });
            setSaveAsModal(false);
          }}
        />
        {pid !== 0 && <GenericButton
          name="Save As"
          btnStyle="button save-as-modal-save-as"
          btnDisabled={fileName.trim() === projectName}
          onBtnClick={handleSaveAsClick}
        />}
      </div>
    </PortalModal>
    <PortalModal
      isShowing={maxLimitModal}
      hide={() => showMaxLimitModal(false)}
      title={CAC_MODULE_TITLE}
      dialogStyles={currClusterModalStyle}
      onCloseClicked={() => showMaxLimitModal(false)}
    >
      <p>{CAC_MAX_LIMIT_REACHED_LABEL}</p>
      <div className="text-center">
        <GenericButton
          name="Ok"
          onBtnClick={() => showMaxLimitModal(false)}
        />
      </div>
    </PortalModal>
  </Fragment>);
}

CacModals.propTypes = {
  saveWarningModal: PropTypes.bool,
  setSaveWarningModal: PropTypes.func,
  saveAsModal: PropTypes.bool,
  setSaveAsModal: PropTypes.func,
  projectName: PropTypes.string,
  saveProject: PropTypes.func,
  tempTitle: PropTypes.string,
  pid: PropTypes.number,
  projectCount: PropTypes.number,
  showMaxLimitPopup: PropTypes.func,
  showMaxLimitModal: PropTypes.func,
  maxLimitModal: PropTypes.bool,
  closeSaveAsModal: PropTypes.func,
  saveFromCloseProject: PropTypes.bool,
  setSaveFromCloseProject: PropTypes.func,
};

export default memo(CacModals);
